module.exports = __webpack_public_path__ + "static/media/banner_2.32208051.jpeg";